import { useQuery } from '@tanstack/react-query';
import { PRODUCTS_STATUS_QUERY_KEY } from '@/apiHooks/queryKeys';
import { getProductsStatus } from '../api/productsStatus/getProductsStatus';
import type { ProductsStatusResponse } from '@/@types/productsStatus';

type ProductsStatusResult = {
  areProductLoading: boolean;
  areProductsRefetching: boolean;
  productsStatus?: ProductsStatusResponse;
  isProductsStatusError?: boolean;
};

export const useGetProductsStatus = (enabled = true): ProductsStatusResult => {
  const { isLoading, data, isError, isRefetching } = useQuery({
    queryKey: PRODUCTS_STATUS_QUERY_KEY,
    queryFn: getProductsStatus,
    enabled,
  });

  return {
    areProductLoading: isLoading,
    areProductsRefetching: isRefetching,
    isProductsStatusError: isError,
    productsStatus: data,
  };
};
